import React from "react";
import { Col } from "reactstrap";
import KpiTabsSection, { KpiTabConfig } from "./KpiTabsSection";
import ChartTabsSection, { ChartTabConfig } from "./ChartTabsSection";
import type { ChartTabId } from "./StockTransferenciasDetailTypes";

type StockTransferenciasDetailAnalyticsProps = {
  kpiTabs: KpiTabConfig[];
  activeKpiTab: string;
  onKpiTabChange: (next: string) => void;
  chartTabs: ChartTabConfig[];
  activeChartTab: ChartTabId;
  onChartTabChange: (next: ChartTabId) => void;
  chartsLoading?: boolean;
  kpisLoading?: boolean;
};

const StockTransferenciasDetailAnalytics: React.FC<StockTransferenciasDetailAnalyticsProps> = ({
  kpiTabs,
  activeKpiTab,
  onKpiTabChange,
  chartTabs,
  activeChartTab,
  onChartTabChange,
  chartsLoading = false,
  kpisLoading = false,
}) => (
  <Col xs={12} className="mt-3">
    <KpiTabsSection
      tabs={kpiTabs}
      activeTab={activeKpiTab}
      onTabChange={onKpiTabChange}
      navClassName="nav-border-top-primary"
      isLoading={kpisLoading}
    />
    <ChartTabsSection
      tabs={chartTabs}
      activeTab={activeChartTab}
      onTabChange={(tab) => onChartTabChange(tab as ChartTabId)}
      navClassName="nav-border-top-success"
      isLoading={chartsLoading}
    />
  </Col>
);

export default StockTransferenciasDetailAnalytics;
